import { render, staticRenderFns } from "./ClipboardModal.vue?vue&type=template&id=13432638"
import script from "./ClipboardModal.vue?vue&type=script&lang=js"
export * from "./ClipboardModal.vue?vue&type=script&lang=js"
import style0 from "./ClipboardModal.vue?vue&type=style&index=0&id=13432638&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports